document.addEventListener('DOMContentLoaded', function() {
    var filters = document.querySelectorAll('.sale-filter-by__item');
    var allFilter = document.querySelector('.sale-filter-by__item[data-filter="all"]');
    
    function addFilterToUrl(filter) {
        var urlParams = new URLSearchParams(window.location.search);
        var filterValue = urlParams.get('filter');
        if (filter === 'all') {
            urlParams.delete('filter');
            window.location.search = urlParams.toString();
            return;
        }
        if (filterValue) {
            filterValue = filterValue.split(',');
            if (filterValue.indexOf(filter) === -1) {
                filterValue.push(filter);
            }
            filterValue = filterValue.join(',');
        } else {
            filterValue = filter;
        }
        urlParams.set('filter', filterValue);
        window.location.search = urlParams.toString();
    }

    function removeFilterFromUrl(filter) {
        var urlParams = new URLSearchParams(window.location.search);
        var filterValue = urlParams.get('filter');
        if (filterValue) {
            filterValue = filterValue.split(',');
            if (filterValue.indexOf(filter) !== -1) {
                filterValue.splice(filterValue.indexOf(filter), 1);
            }
            filterValue = filterValue.join(',');
        }
        urlParams.set('filter', filterValue);
        window.location.search = urlParams.toString();
    }

    function init() {
        var urlParams = new URLSearchParams(window.location.search);
        var filterValue = urlParams.get('filter');
        var isRemoveAll = false;
        if (filterValue) {
            filterValue = filterValue.split(',');
            filters.forEach(function(filter) {
                if (filterValue.indexOf(filter.dataset.filter) !== -1) {
                    !isRemoveAll && allFilter.classList.remove('active');
                    isRemoveAll = true;
                    filter.classList.add('active');
                } else {
                    var target_filter = document.querySelector('[data-sale-filter="'+ filter.dataset.filter +'"]')
                    target_filter && target_filter.closest('.q-sale-product-recommendation') && target_filter.closest('.q-sale-product-recommendation').classList.add('t4s-d-none');
                    target_filter && target_filter.closest('.new-grid-item-list') &&target_filter.closest('.new-grid-item-list').classList.add('t4s-d-none');
                }
            })
        }
        isRemoveAll || allFilter.classList.add('active');
    }

    init();
    filters.forEach(function(filter) {
        filter.addEventListener('click', function() {
            if (this.dataset.filter === 'all') {
                if (this.classList.contains('active')) return;

                filters.forEach(function(filter) {
                    filter.classList.remove('active');
                });
                // this.classList.add('active');
                addFilterToUrl('all');
                return;
            }
            if (this.classList.contains('active')) {
                this.classList.remove('active');
                removeFilterFromUrl(this.dataset.filter);
                return;
            }
            allFilter.classList.remove('active');
            // this.classList.add('active');
            addFilterToUrl(this.dataset.filter);
        });
    });
})